import { Stack } from '@ui-components/neo.tax';
import { useEffect } from 'react';

import { useAscContext } from '@neo.tax/asc/context';
import {
  AnalysisType,
  OnboardingFlowStage,
  useOnboardingFlowStage,
  useUnfinishedSyncEventInPeriodByAnalysisType,
  AnalysisInfo,
  GetStartedHero,
  OnboardingFlowProcessingHero,
} from '@neo.tax/shared';

import { AscProjectsLayout } from '../asc-projects-layout';

export const AscProjectsLoader = (): React.ReactElement => {
  const { stage, startPolling, stopPolling } = useOnboardingFlowStage();
  const { fiscalYearId, period, periodName } = useAscContext();

  const { period: unfinishedSyncEventsPeriod } = useUnfinishedSyncEventInPeriodByAnalysisType({
    fiscalYearId,
    periodName,
    analysisType: AnalysisType.Asc,
  });
  useEffect(() => {
    // Start polling after the user submits their data and the stage changes to DATA_PROCESSING_IN_PROGRESS
    if (stage === OnboardingFlowStage.DATA_PROCESSING_IN_PROGRESS) {
      startPolling(5000);
    } else {
      stopPolling();
    }
  }, [stage, startPolling, stopPolling]);

  if (
    stage === OnboardingFlowStage.DATA_PROCESSING_COMPLETED ||
    (stage === OnboardingFlowStage.DATA_PROCESSING_IN_PROGRESS && !unfinishedSyncEventsPeriod)
  ) {
    return <AscProjectsLayout />;
  }

  return (
    <Stack fullHeight direction="column" paddingY={8} paddingX={6} gap={6}>
      {stage === OnboardingFlowStage.INITIAL ? (
        <GetStartedHero
          analysisType={AnalysisType.Asc}
          fiscalYearId={fiscalYearId}
          periodName={periodName}
          period={period}
        />
      ) : (
        <OnboardingFlowProcessingHero />
      )}
      <AnalysisInfo />
    </Stack>
  );
};
